'use client';

import { redirect } from 'next/navigation';

import Loading from 'components/Loading';
import * as S from 'components/shared-styles-v2';
import { TF_DASHBOARD_ROUTE, OFFLINE_TEACHER_DASHBOARD_PATH, UNAUTHORIZED_USER_PATH } from 'config/internalUrlPaths';
import { useTeacherContext, useUserContext } from 'context/Profile';
import { Permissions } from 'model/profiles';

const Page = () => {
  const { user } = useUserContext();
  const { hasPermission } = useTeacherContext();

  if (!user) {
    return (
      <S.FullscreenCenter>
        <Loading />
      </S.FullscreenCenter>
    );
  }

  // Check if user has neither portal nor offline permissions
  if (!hasPermission(Permissions.VIEW_TEACHERS_PORTAL) && !hasPermission(Permissions.VIEW_OFFLINE_TEACHERS_DASHBOARD)) {
    redirect(UNAUTHORIZED_USER_PATH);
  }

  // If user doesn't have portal access but has offline access, redirect to offline
  if (!hasPermission(Permissions.VIEW_TEACHERS_PORTAL)) {
    redirect(OFFLINE_TEACHER_DASHBOARD_PATH);
  }

  // Otherwise redirect to normal dashboard
  redirect(TF_DASHBOARD_ROUTE);
};

export default Page;
